import { carColors } from "@constants/mock-data";

export const getImageRows = (
  images: typeof carColors
): (typeof carColors)[] => {
  const total = images?.length;
  const rows: (typeof carColors)[] = [];

  let row1 = 0;
  let row2 = 0;
  let row3 = 0;

  if (total <= 2) {
    row1 = total;
  } else if (total === 3) {
    row1 = 2;
    row2 = 1;
  } else if (total === 4) {
    row1 = 2;
    row2 = 2;
  } else if (total === 5) {
    row1 = 2;
    row2 = 2;
    row3 = 1;
  } else if (total === 6) {
    row1 = row2 = row3 = 2;
  } else {
    const approx = Math.ceil(total / 3);
    row1 = approx;
    row2 = approx;
    row3 = total - row1 - row2;

    // Adjust if row3 becomes negative
    if (row3 < 0) {
      row3 = 0;
      row2 = total - row1;
    }
  }

  let start = 0;
  rows.push(images?.slice(start, start + row1));
  start += row1;

  if (row2 > 0) {
    rows.push(images?.slice(start, start + row2));
    start += row2;
  }

  if (row3 > 0) {
    rows.push(images?.slice(start, start + row3));
  }

  return rows;
};
